export default class Logger {

    static log(message) {
        if (typeof window !== 'undefined') {
            if (window.equaloneLoggerEnabled) {
                if (message instanceof Error) {
                    console.error(message.message + '(#' + message.code + ')');
                    console.error(message);
                } else {
                    console.log(message);
                }
            }
        }
    }

}


// WEBPACK FOOTER //
// ./js/core/utils/Logger.js